import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-unstable-nested-components */
import React, { useRef, Children } from "react";
import Slider from "react-slick";
import Arrow from "Images/profile/rightArrow.svg";
import ArrowWhite from "Images/profile/right-arrow-white.svg";
import styles from "./style.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
/**
 * Custom carousel component
 */
const CustomCarousel = ({ className, children, extraSettings, arrowsRight, arrowsVertical = false, minimumSlides, dotsWrapperStyles, dotsStyles, fullWidth, arrowsOnSides, arrowsRounded, white, }) => {
    const sliderRef = useRef(null);
    const next = () => {
        sliderRef.current && sliderRef.current.slickNext();
    };
    const previous = () => {
        sliderRef.current && sliderRef.current.slickPrev();
    };
    const settings = {
        slidesToShow: 1,
        speed: 500,
        dots: true,
        appendDots: (dots) => (_jsx("div", { style: {
                width: "100%",
                bottom: "-40px",
                display: "flex",
                justifyContent: "flex-start",
                ...dotsWrapperStyles,
            }, children: dots })),
        customPaging: () => (_jsx("div", { className: `custom-dot ${white && "custom-dot-white"}`, style: {
                width: "16px",
                height: "2px",
                backgroundColor: "rgba(51, 51, 51, 0.2)",
                zIndex: 10,
                ...dotsStyles,
            } })),
        swipe: true,
    };
    return (_jsxs("div", { className: `${arrowsOnSides && styles.carousel__wrapper_on_sides} ${styles.carousel__wrapper} ${className} ${fullWidth ? styles.carousel__fullWidth : ""}`, children: [_jsx(Slider, { ref: sliderRef, ...settings, ...extraSettings, children: children }), arrowsOnSides && (_jsxs("div", { className: styles.arrows_wrapper_on_sides, children: [_jsx("button", { className: styles.arrow_button, type: "button", onClick: previous, children: _jsx("img", { className: `${styles.carousel_arrow} ${styles.carousel_arrow_left_on_side}`, src: white ? ArrowWhite : Arrow, alt: "left" }) }), _jsx("button", { className: styles.arrow_button, type: "button", onClick: next, children: _jsx("img", { className: `${styles.carousel_arrow} ${styles.carousel_arrow_right_on_side}`, src: white ? ArrowWhite : Arrow, alt: "right" }) })] })), minimumSlides && Children.count(children) > minimumSlides ? (_jsxs("div", { className: `${styles.arrows_wrapper}
            ${arrowsVertical ? styles.arrows_wrapper_vertical : ""}
            ${arrowsRight ? styles.arrows_wrapper_right : ""}
            ${arrowsRounded ? styles.arrows_wrapper_rounded : ""}`, children: [_jsx("button", { className: styles.arrow_button, type: "button", onClick: previous, children: _jsx("img", { className: `${styles.carousel_arrow} ${styles.carousel_arrow_left}`, src: white ? ArrowWhite : Arrow, alt: "left" }) }), _jsx("button", { className: styles.arrow_button, type: "button", onClick: next, children: _jsx("img", { className: `${styles.carousel_arrow}`, src: white ? ArrowWhite : Arrow, alt: "right" }) })] })) : null] }));
};
export default CustomCarousel;
